module.exports = __webpack_public_path__ + "img/AS.0ac165c3.svg";